import { useAuthStore } from '@clarix/auth-store';
import { useLogout } from '@/core/api';
import { DocumentMeta } from '@/gateway/DocumentMeta';
import { AuroraBackdrop } from './auth/AuroraBackdrop';
import { AuthHeadline } from './auth/AuthHeadline';
import { AuthRouteTransition } from './auth/AuthRouteTransition';

/**
 * Layout for the onboarding wizard. Same split-panel chrome as AuthShell —
 * route-aware informative panel on the left, the workspace-creation form on
 * the right — with the aurora backdrop and a discreet sign-out so the
 * authenticated user can still bail without a workspace.
 */
export function OnboardingShell() {
  const userEmail = useAuthStore((s) => s.user?.email);
  const logout = useLogout();

  return (
    <div className="relative grid min-h-screen w-full p-4 lg:grid-cols-2 lg:p-8">
      {/* Onboarding belongs to no app — keep the generic Clarix brand. */}
      <DocumentMeta />
      <AuroraBackdrop />

      <div className="absolute right-4 top-4 z-20 flex items-center gap-3 text-lg text-slate-600 dark:text-slate-300">
        {userEmail && <span className="hidden sm:inline">{userEmail}</span>}
        <button
          type="button"
          className="rounded-md px-2 py-1 text-slate-500 hover:bg-white/40 hover:text-slate-900 dark:hover:bg-white/10 dark:hover:text-slate-100"
          onClick={() => logout.mutate()}
        >
          Sign out
        </button>
      </div>

      {/* Left — informative panel (hidden on mobile) */}
      <div className="relative z-10 hidden flex-col justify-center pl-48 lg:flex">
        <AuthHeadline />
      </div>

      {/* Right — onboarding form */}
      <div className="relative z-10 flex items-center justify-center px-4 py-8 lg:px-6 lg:py-12">
        <div className="w-full max-w-xl">
          <AuthRouteTransition />
        </div>
      </div>
    </div>
  );
}
